// extracted by mini-css-extract-plugin
module.exports = {"prices":"Prices_prices__sXF0h"};